export default __webpack_public_path__ + "static/media/Sycamore Icons-01.4ae18a16.svg";